import { useMutation } from '@tanstack/react-query'
import { useApiClient } from 'hooks/useApiClient'
import { type FileRequest } from 'types/fileUpload'

interface usePostEmployeesExcludeProps {
  onSuccess?: (data: unknown, variables: FileRequest) => void
  onError?: (error: Error, variables: FileRequest) => void
}

export const usePostEmployeesExclude = ({
  onSuccess,
  onError,
}: usePostEmployeesExcludeProps) => {
  const postAPIClient = useApiClient()

  return useMutation({
    mutationFn: async (importFile: FileRequest) => {
      const body = new FormData()
      body.set('FileUpload', importFile.File)
      body.set('FileUploadName', importFile.FileName)
      body.set('FileUploadType', importFile.FileType)

      const { data, error } = await postAPIClient.post(
        '/admin/utilities/employees/excludebyphone',
        {
          params: {},
          body: {},
          bodySerializer: () => body,
        }
      )
      return { data, error }
    },
    onSuccess: async ({ data, error }, variables: FileRequest) => {
      if (error !== undefined) {
        onError?.(error as Error, variables)
      } else {
        onSuccess?.(data as unknown, variables)
      }
    },
    onError,
  })
}
